import React, { Component } from 'react';
import { Container } from 'reactstrap';
import  NavMenu  from './NavMenu';

export class Layout extends Component {
  static displayName = Layout.name;

  render() {
    return (
      <div>
        <NavMenu />
        <div style={{ borderTop: "1px solid #ccc", marginBottom: "20px"}}></div>
        <Container tag="main">
          {this.props.children}
        </Container>
      </div>
    );
  }
}
